export const REACT_APP_BASE_BE_URL = `https://api.${window.location.host.split('.').shift()}.zoominfo.com`;
export const REACT_APP_BASE_FE_URL = `https://${window.location.host.split('.').shift()}.zoominfo.com/`;
export const MICROSOFT_CLIENT_ID = window.location.host.split('.').shift() === "schedule"
    ?
    "ec043e4b-635f-4285-818f-203a79ccb95a"
    :
    "c0a3cc6f-fa0d-4380-8b89-355ac7866a02"
;

export const GOOGLE_CLIENT_ID = window.location.host.split('.').shift() === "schedule"
    ?
    "134721002487-j7ffrgvpltfhagot4ijpv47j4960jdnm.apps.googleusercontent.com"
    :
    "577406107679-3tfcbctn75rn2ea55nt75baogv5gvnkt.apps.googleusercontent.com";

export const CAPTCHA_SITE_KEY = window.location.host.split('.').shift() === "schedule"
    ?
    "6Ld8jsgqAAAAAHsHqzHELhtz7FCpYgj_29XnWW1d"
    :
    "6Lf-AcgqAAAAAIVCRjmA54D_xiEwxXhKPSmuQteM"